var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFile
    ? _c(
        "div",
        { staticClass: "pdf-viewport-container container" },
        [
          _vm.pages && _vm.loaded
            ? _c("PdfViewportTools", {
                attrs: { pages: _vm.pages },
                model: {
                  value: _vm.page,
                  callback: function($$v) {
                    _vm.page = $$v
                  },
                  expression: "page"
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              ref: "pdfViewport",
              staticClass: "pdf-viewport",
              on: { click: _vm.onViewportClick }
            },
            [
              _vm._l(_vm.signaturesByPage, function(signature) {
                return _c(signature.type || _vm.signatureType, {
                  key: signature.id,
                  tag: "component",
                  attrs: {
                    name: signature.name,
                    x: signature.x,
                    y: signature.y,
                    transform: signature.transform,
                    bounds: _vm.bounds,
                    closable: _vm.closableSign,
                    meta: signature.meta
                  },
                  on: {
                    "drag-end": function($event) {
                      return _vm.onSignatureDragEnd($event, signature)
                    },
                    close: function($event) {
                      return _vm.$emit("signature-delete", signature)
                    }
                  }
                })
              }),
              !_vm.publicandoFile
                ? _c("Pdf", {
                    ref: "page",
                    staticClass: "m-auto",
                    class: { "hide-document": _vm.hideDocument },
                    attrs: { page: _vm.actualPage, src: _vm.file },
                    on: { "page-loaded": _vm.loadedPage }
                  })
                : _vm._e()
            ],
            2
          ),
          _c("b-overlay", { attrs: { show: !_vm.loaded, "no-wrap": "" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }